'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFitnessCenter = function MdFitnessCenter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.3 24.8l2.3 2.4-3.5 3.5 2.4 2.4-2.4 2.4-2.4-2.4-3.5 3.5-2.4-2.3-2.4 2.3-2.4-2.3 5.9-5.9-14.3-14.3-5.9 5.9-2.3-2.4 2.3-2.4-2.3-2.4 3.5-3.5-2.4-2.4 2.4-2.4 2.4 2.4 3.5-3.5 2.4 2.3 2.4-2.3 2.4 2.3-5.9 5.9 14.3 14.3 5.9-5.9 2.3 2.4z' })
        )
    );
};

exports.default = MdFitnessCenter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/fitness-center.js
// module id = 2336
// module chunks = 0